<template>
  <div class="flex w-full items-center overflow-x-auto overflow-y-hidden" :class="external ? 'h-40' : 'h-60'">
    <div v-for="(file, idx) in files" class="relative p-2" :key="`file_${idx}`" :class="imageFile(file) ? 'pb-8' : ''">
      <div v-if="imageFile(file)" :class="external ? 'h-20 w-20' : 'h-40 w-40'">
        <div class="flex h-full items-center justify-center space-y-1 rounded-t bg-gray-900/50 px-1 py-1">
          <div class="flex h-full items-center">
            <img class="max-h-full" :src="getUrl(file)" :alt="file.name" />
          </div>
        </div>
        <div
          class="line-clamp-1 whitespace-nowrap rounded-bl rounded-br bg-gray-900/50 px-1 py-1 text-xs text-gray-400"
        >
          {{ truncate(file.name, truncateLength) }}
        </div>
      </div>
      <div v-else-if="file.type.startsWith('video/')">
        <div
          class="flex flex-col items-center justify-center space-y-1 rounded-t bg-gray-900/50 px-1 py-1"
          :class="external ? 'h-20' : 'h-40 w-40'"
        >
          <MimeTypeIcons :mime-type="file.type" size="h-16 w-16 text-gray-400" />
        </div>
        <div
          class="line-clamp-1 whitespace-nowrap rounded-bl rounded-br bg-gray-900/50 px-1 py-1 text-xs text-gray-400"
        >
          {{ truncate(file.name, truncateLength) }}
        </div>
      </div>
      <div v-else>
        <div
          class="flex flex-col items-center justify-center space-y-1 rounded-t bg-gray-900/50 px-1 py-1"
          :class="external ? 'h-20' : 'h-40 w-40'"
        >
          <MimeTypeIcons :mime-type="file.type" size="h-16 w-16 text-gray-400" />
        </div>
        <div
          class="line-clamp-1 whitespace-nowrap rounded-bl rounded-br bg-gray-900/50 px-1 py-1 text-xs text-gray-400"
        >
          {{ truncate(file.name, truncateLength) }}
        </div>
      </div>
      <div class="absolute right-0" style="top: -3px" @click="$emit('remove-file', file.name)">
        <TrashIcon class="h-5 w-5 cursor-pointer text-gray-400 hover:text-red-500" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { TrashIcon } from '@heroicons/vue/20/solid';
import { truncate } from '@/composeables/filters';
import MimeTypeIcons from '@/components/MimeTypeIcons.vue';
const props = defineProps({
  files: Array,
  external: {
    type: Boolean,
    default: false
  }
});
const truncateLength = computed(() => {
  return props.external ? 10 : 20;
});

function getUrl(file) {
  return URL.createObjectURL(file);
}
function imageFile(file) {
  return file.type.startsWith('image/') && !file.type.endsWith('.photoshop');
}
</script>
